"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorToolController = void 0;
class TopologicalEditorToolController {
    constructor(topologicalEditorController) {
        this.topologicalEditorController = topologicalEditorController;
    }
}
exports.TopologicalEditorToolController = TopologicalEditorToolController;
//# sourceMappingURL=topological.editor.tool.abstract.ctrl.js.map